import {createApp,inject} from "vue";
import VmModalComponent from '@/js/vue/modal/components/VmModal.vue';
export const VmModalKey = Symbol('VmModal')

let vmModal = null
const MODAL_MOUNT_ID = 'modal'

function mountModal() {
    const el = document.getElementById(MODAL_MOUNT_ID)
    if (!el) return null

    const app = createApp(VmModalComponent)
    return app.mount(el)
}

/**
 * JS / composable外向けのモーダル呼び出し関数
 * @return {*}
 *
 * ex.
 * import { getVmModal } from '@/js/modal'
 * getVmModal()?.open({ component: MyModal, vars: {...}, type: 'popup' })
 */
export function getVmModal() {
    if (!vmModal) {
        vmModal = mountModal()

        if (!vmModal) {
            console.warn(`[VmModal] mount target #${MODAL_MOUNT_ID} was not found.`)
        }

        // 必要ならグローバル公開
        window.VmModal = vmModal
    }

    return vmModal
}

/**
 * Vue用
 * ex.
 * import { useVmModal } from '@/js/modal'
 * const vmModal = useVmModal()
 * vmModal?.open({ component: MyModal, vars: {...}, type: 'popup' })
 * */
export function useVmModal() {
    //  plugin未使用でも落ちないためのnull
    return inject(VmModalKey, null)
}

/**
 * ex.
 * import { VmModalPlugin } from '@/js/modal'
 * createApp(Component).use(VmModalPlugin).mount('#app')
 * */
export const VmModalPlugin = {
    install(app) {
        const modal = getVmModal()
        app.provide(VmModalKey, modal)
    }
}

